import { FC } from 'react'
import styled from 'styled-components'
import { mobileBreakPoint } from 'app.styled/media'
import NewsReactionCard, { UserCardItem } from './NewsReactionCard'
import NewsReactionEmpty from './NewsReactionEmpty'
import NewsReactionLoading from './NewsReactionLoading'

type TProps = {
  data: UserCardItem[]
  loading: boolean
}

const NewsReactionList: FC<TProps> = ({ data, loading }) => {
  if (loading) return <NewsReactionLoading />
  if (!loading && !data.length) return <NewsReactionEmpty />

  return (
    <StyledWrapper>
      {data.map((item) => (
        <NewsReactionCard key={item.name} data={item} />
      ))}
    </StyledWrapper>
  )
}

export default NewsReactionList

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  padding: 0 30px;

  ${mobileBreakPoint} {
    padding: 0 20px;
  }
`
